import React, { useEffect, useState } from "react";
import FormComponent from "../../../../../components/gernerateForm/FormComponent";
import generateForm06 from "../data/form06.data";

type Props = {
  onSubmit?: (value: any) => void;
  isValidateForm: boolean;
  data: any;
  setData: (value: any) => void;
  mainInputValue: any;
  isValudateFile: boolean;
  isCanEdit?: boolean | true;
};
const Form06: React.FC<Props> = (props: Props) => {
  const {
    onSubmit,
    isValidateForm,
    data,
    setData,
    mainInputValue,
    isValudateFile,
    isCanEdit,
  } = props;

  const [inputValueFormLeave06, setInputValueFormLeave06] = useState({
    information: {
      title_en: "",
      first_name_en: "",
      last_name_en: "",
      buddhist_name_en: "",
    },
    operational_data: {
      organization: "",
      country: "",
      position: "",
      level: "",
      duties_performed: "",
    },
    contact_work: {
      contact_name: "",
      detail: "",
      sub_detail: "",
    },
    period_time_work: {
      year_amount: 0,
      month_amount: 0,
      day_amount: 0,
      departure_date: "",
    },
    // current_contact_address: {
    //   house_no: "",
    //   street: "",
    //   country: "",
    //   province: "",
    //   district: "",
    //   district_sub: "",
    //   village: "",
    //   postcode: "",
    // },
    remuneration: {
      thb: 0,
    },
    remuneration_info: {
      saraly_rate: "",
      accommodation_costs: "",
      transportation_costs: "",
      other: "",
      is_check_saraly_rate: false,
      is_check_accommodation_costs: false,
      is_check_transportation_costs: false,
      is_check_other: false,
    },
    // info_about_religious_continued: {
    //   organization_requesting_work: "",
    //   position: "",
    //   level: "",
    //   start_date: "",
    //   end_date: "",
    //   reasons_necessity_continue: "",
    //   benefit_university_receive: "",
    // },
  });

  useEffect(() => {
    const information = mainInputValue.information;
    const condition = inputValueFormLeave06.information;
    const operational_data = inputValueFormLeave06.operational_data;
    const contact_work = inputValueFormLeave06.contact_work;
    const period_time_work = inputValueFormLeave06.period_time_work;
    const remuneration = inputValueFormLeave06.remuneration;
    const remuneration_info = inputValueFormLeave06.remuneration_info;

    setData({
      main: information,
      condition: condition,
      operational_data: operational_data,
      contact_work: contact_work,
      period_time_work: period_time_work,
      remuneration: remuneration,
      remuneration_info: remuneration_info,
    });
  }, [inputValueFormLeave06]);

  useEffect(() => {
    if (data) {
      setInputValueFormLeave06({
        information: data.condition,
        operational_data: data.operational_data,
        contact_work: data.contact_work,
        period_time_work: data.period_time_work,
        remuneration: data.remuneration,
        remuneration_info: data.remuneration_info,
      });
    }
  }, []);

  return (
    <div
    // onClick={() => {
    //   onSubmit("text");
    // }}
    >
      <FormComponent
        formGenerate={generateForm06}
        inputValue={inputValueFormLeave06}
        setInputValue={setInputValueFormLeave06}
        handleCheckValid={isValidateForm}
        isCanEdit={isCanEdit ?? true}
        permission={"admin"}
      />
    </div>
  );
};

export default Form06;
